import { Component, OnInit } from '@angular/core';
import {ContactService} from '../../services/contact.service'
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit {
  contacts:any =[]
  constructor(public contactService:ContactService,public common:CommonService) { }

  ngOnInit(): void {
    this.common.showLoader()
    this.contactService.getRecipients().subscribe((res:any)=>{
      this.contacts=res.message;
      //console.log(res)
      this.common.stopLoader()
    })
  }





}
